import React from 'react';
import { Cpu, Activity, Database, Server, Zap } from 'lucide-react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../../../components/ui/card';
import BackButton from '../../../components/admin/BackButton';

const AssistantSystem = () => {
  const metrics = [
    { label: "CPU Usage", value: "23%", icon: Cpu, color: "text-blue-600" },
    { label: "Memory", value: "1.2 GB", icon: Server, color: "text-green-600" },
    { label: "Database", value: "Active", icon: Database, color: "text-purple-600" },
    { label: "Performance", value: "98%", icon: Zap, color: "text-yellow-600" }
  ];

  const optimizations = [
    {
      title: "Database Indexing",
      description: "Optimize database queries for faster response times",
      impact: "High"
    },
    {
      title: "Cache Strategy",
      description: "Implement caching for frequently accessed data",
      impact: "Medium"
    },
    {
      title: "API Rate Limiting",
      description: "Protect API endpoints from abuse",
      impact: "High"
    }
  ];

  return (
    <div>
      <BackButton />
      
      <div className="mb-8">
        <div className="flex items-center space-x-3">
          <div className="p-3 bg-green-500 bg-opacity-10 rounded-lg">
            <Cpu className="h-6 w-6 text-green-600" />
          </div>
          <div>
            <h2 className="text-2xl font-bold text-[#2B2D42]">System Intelligence</h2>
            <p className="text-sm text-[#6C757D]">Platform optimization and performance monitoring</p>
          </div>
        </div>
      </div>

      {/* System Metrics */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
        {metrics.map((metric, index) => {
          const Icon = metric.icon;
          return (
            <Card key={index}>
              <CardContent className="pt-6">
                <div className="flex items-center justify-between">
                  <div>
                    <p className="text-sm text-[#6C757D] mb-1">{metric.label}</p>
                    <p className="text-2xl font-bold text-[#2B2D42]">{metric.value}</p>
                  </div>
                  <div className="p-3 bg-gray-100 rounded-lg">
                    <Icon className={`h-6 w-6 ${metric.color}`} />
                  </div>
                </div>
              </CardContent>
            </Card>
          );
        })}
      </div>

      {/* Optimization Recommendations */}
      <div>
        <h3 className="text-xl font-bold text-[#2B2D42] mb-4">Optimization Recommendations</h3>
        <div className="space-y-4">
          {optimizations.map((opt, index) => (
            <Card key={index}>
              <CardHeader>
                <div className="flex items-start justify-between">
                  <div>
                    <CardTitle className="text-lg">{opt.title}</CardTitle>
                    <CardDescription>{opt.description}</CardDescription>
                  </div>
                  <span
                    className={`px-3 py-1 text-xs rounded-full ${
                      opt.impact === 'High'
                        ? 'bg-red-100 text-red-800'
                        : 'bg-yellow-100 text-yellow-800'
                    }`}
                  >
                    {opt.impact} Impact
                  </span>
                </div>
              </CardHeader>
            </Card>
          ))}
        </div>
      </div>

      <Card className="mt-8 bg-green-50 border-green-200">
        <CardContent className="pt-6">
          <p className="text-sm text-[#6C757D]">
            🧠 <strong>System Intelligence</strong> will continuously monitor platform performance and suggest optimizations. 
            This feature is under development.
          </p>
        </CardContent>
      </Card>
    </div>
  );
};

export default AssistantSystem;